import React, { useState } from "react";
import "./ContactPage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faMapMarkerAlt, faClock } from "@fortawesome/free-solid-svg-icons";
import { FaCheckCircle } from 'react-icons/fa'; // Importing check circle icon

const ContactPage = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    message: "",
    product: "",
    timeline: "",
    budget: "",
  });

  const [notification, setNotification] = useState(""); // State for custom notifications
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, mobile, email, product, timeline, budget, message } = formData;

    // Validate required fields
    if (!firstName || !mobile || !email || !product || !message) {
      setNotification("Please fill in all required fields.");
      setTimeout(() => setNotification(""), 5000); // Clear the notification after 5 seconds
      return;
    }

    // Prepare request data
    const requestData = {
      firstName,
      lastName,
      mobileNumber: mobile,
      email,
      product,
      projectTimeline: timeline,
      budget,
      message,
      receiverEmail: "kiruthvikg@gmail.com", // Replace with your desired email
    };

    try {
      // Send API request
      const response = await fetch("https://portfolio-backend-stmn.onrender.com/send-email_portfolio", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (response.ok) {
        setNotification("Email sent successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          message: "",
          product: "",
          timeline: "",
          budget: "",
        });
        setIsModalOpen(true); // Open the modal on success
      } else {
        setNotification(data.message || "Failed to send email.");
      }
    } catch (error) {
      setNotification("Error sending email. Please try again later.");
    }

    setTimeout(() => setNotification(""), 5000); // Clear the notification after 5 seconds
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Left Section */}
        <div className="contact-info">
          <h2 style={{ color: "wheat" }}>Get In Touch With Us Now!</h2>
          <div className="info-row">
            <div className="info-box">
              <FontAwesomeIcon icon={faPhone} className="icon" />
              <h3>Phone Number</h3>
              <p style={{ color: "wheat" }}>+91 70102 78394</p>
            </div>
            <div className="info-box">
              <FontAwesomeIcon icon={faEnvelope} className="icon" />
              <h3>Email</h3>
              <p style={{ color: "wheat" }}>kiruthvikg@gmail.com</p>
            </div>
          </div>
          <div className="info-row">
            <div className="info-box">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="icon" />
              <h3>Location</h3>
              <p style={{ color: "wheat" }}>Chennai, Saligramam</p>
            </div>
            <div className="info-box">
              <FontAwesomeIcon icon={faClock} className="icon" />
              <h3>Working Hours</h3>
              <p style={{ color: "wheat" }}>Monday To Sunday</p>
              <p style={{ color: "wheat" }}>08:00 AM To 11:00 PM</p>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="contact-form">
          <h2>Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <input
                type="text"
                name="firstName"
                placeholder="First Name *"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
            <div className="form-row">
              <input
                type="text"
                name="mobile"
                placeholder="Mobile No *"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email ID *"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-row">
              <select
                name="product"
                value={formData.product}
                onChange={handleChange}
                required
              >
                <option value="">Select Product *</option>
                <option value="Mobile App Development">Mobile App Development</option>
                <option value="Web Development">Web Development</option>
                <option value="UI/UX Design">UI/UX Design</option>
                <option value="Enterprise Solutions">Enterprise Solutions</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="form-row">
              <input
                type="text"
                name="timeline"
                placeholder="Project Timeline (e.g., 3 months)"
                value={formData.timeline}
                onChange={handleChange}
              />
              <input
                type="number"
                name="budget"
                placeholder="Project Budget Estimate ($)"
                value={formData.budget}
                onChange={handleChange}
              />
            </div>

            <div className="form-row">
              <textarea
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            <button type="submit" className="submit-button">
              Submit
            </button>
          </form>
        </div>
      </div>

      {/* Custom Notification */}
      {notification && (
        <div className="custom-notification">
          <p>{notification}</p>
        </div>
      )}

      {/* Modal Popup for Success Message */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2><FaCheckCircle style={{ color: 'green', marginRight: '8px' }} />Thank you!</h2>
            <p>Our representative will contact you within 24 hours on working days.</p>
            <button onClick={() => setIsModalOpen(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactPage;
